import { render } from "./TransferFailed.vue?vue&type=template&id=39760183&scoped=true"
import script from "./TransferFailed.vue?vue&type=script&lang=js"
export * from "./TransferFailed.vue?vue&type=script&lang=js"

import "./TransferFailed.vue?vue&type=style&index=0&id=39760183&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39760183"]])

export default __exports__